import Vue from 'vue';

import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

import { fas } from '@fortawesome/free-solid-svg-icons';
import { far } from '@fortawesome/free-regular-svg-icons';
// import { fal } from '@fortawesome/pro-light-svg-icons';
// import { fad } from '@fortawesome/pro-duotone-svg-icons';

library.add(fas, far);

Vue.component('fa-icon', FontAwesomeIcon);
